module.exports = __webpack_public_path__ + "static/media/products-visual.80d91914.png";